<sba-exercise-container #exerciseContainer (start)="onStart($event)">
  <ng-container>
    <div id="game" #game></div>
  </ng-container>
</sba-exercise-container>
